import { render, staticRenderFns } from "./InlineVideo.vue?vue&type=template&id=5235ab26&"
import script from "./InlineVideo.vue?vue&type=script&lang=ts&"
export * from "./InlineVideo.vue?vue&type=script&lang=ts&"
import style0 from "./InlineVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/tmp/build_dc55b0b5/src/components/button/Button.vue').default})
